import { jsx as _jsx } from "react/jsx-runtime";
// 1. Ant Design
import { Drawer } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 3. Internal components
import CompanyLinks from "@/components/CompanyLinks/CompanyLinks";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
import { canManageCompanies } from "@/utils/permissions";
/**
 * «Компании клиента» (P-12, UC1117): привязки клиента ко всем компаниям (`v_corp_client_links`, BR-LNK-22)
 * тем же компонентом `CompanyLinks`, что и вкладка «Сотрудники», с API в разрезе клиента.
 */
const ClientCompaniesDrawer = observer(({ client, open, onClose }) => {
    const { authStore, clientCompaniesStore, companiesStore } = getRootStore();
    const canManage = canManageCompanies(authStore.userRole);
    useEffect(() => {
        if (!open)
            return undefined;
        clientCompaniesStore.initForClient(client.id, { readOnly: !canManage });
        if (canManage)
            void companiesStore.loadCompanyOptions();
        return () => clientCompaniesStore.dispose();
    }, [open, client.id]);
    const fullName = [client.firstName, client.lastName].filter(Boolean).join(" ") || "клиент";
    return (_jsx(Drawer, { open: open, onClose: onClose, width: 1040, title: `Компании клиента: ${fullName}`, destroyOnHidden: true, children: open ? (_jsx("div", { "data-testid": "corp-client-companies-drawer", children: _jsx(CompanyLinks, { store: clientCompaniesStore, companyOptions: companiesStore.companyOptions.map((company) => ({ value: company.id, label: company.name })), clientPhone: client.phone?.trim() || null, emptyText: "\u041A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u043D\u0438 \u043A \u043E\u0434\u043D\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438" }) })) : null }));
});
ClientCompaniesDrawer.displayName = "ClientCompaniesDrawer";
export default ClientCompaniesDrawer;
